export default defineNuxtPlugin(() => {
  // Suppress the known MDC slot warning that doesn't affect functionality
  // Issue: https://github.com/nuxt-modules/mdc/issues/197
  const originalWarn = console.warn
  console.warn = (...args: any[]) => {
    const message = args[0]
    if (
      typeof message === 'string' &&
      message.includes('Slot "default" invoked outside of the render function') &&
      args.some((arg: any) => 
        typeof arg === 'string' && (arg.includes('ProseP') || arg.includes('MDCRenderer'))
      )
    ) {
      // Suppress this specific warning
      return
    }
    originalWarn(...args)
  }
})

